import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics';

export const AnalyticsRouteTracker = () => {
    const location = useLocation();

    useEffect(() => {
        trackPageView({
            route_path: location.pathname,
            route_search: location.search || null,
            route_hash: location.hash || null,
        });
    }, [location.pathname, location.search, location.hash]);

    return null;
};
